module.exports = __webpack_public_path__ + "img/tiktok.c56fab0a.svg";